import React from 'react';

import { Box, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const TitleIcon = ({ fontWeight, icon, title, variant = 'h4' }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {icon}
        <Typography variant={variant} fontWeight={fontWeight}>
            {title}
        </Typography>
    </Box>
);

TitleIcon.propTypes = {
    fontWeight: PropTypes.string,
    icon: PropTypes.object,
    title: PropTypes.string,
    variant: PropTypes.string,
};

export default TitleIcon;
